module.exports = __webpack_public_path__ + "static/media/dark-plus.9cba588f.svg";